export default {
    "global" : {
        required: true,
        regex: /^[^<>]+$/
    },
    "email" : {
        email: true
    },
    "Comments__c" : {
        required: false
    },
    "Sales_Contact_Requested__c" : {
        required: false
    }
}
